import type { TenantContent } from '@/types/tenant.types';
import {
  getAuthLogoUrl,
  getOnBoardingImageUrl,
  getOnBoardingSignUpImageUrl,
  getWhiteLogoUrl,
} from './tenantImages';

/**
 * Warms the browser cache with the images the login, sign-up and MFA pages show, as soon as the
 * tenant content is known, so those pages paint with their images already loaded.
 * Each URL is requested once per session; failures are ignored (the page shows its own fallback).
 */
const requested = new Set<string>();
// Held so the requests aren't garbage-collected before they finish
const inFlight: HTMLImageElement[] = [];

export function preloadAuthImages(content: TenantContent | null): void {
  if (!content || typeof Image === 'undefined') return;
  const urls = [
    getOnBoardingImageUrl(content),
    getOnBoardingSignUpImageUrl(content),
    getWhiteLogoUrl(content),
    getAuthLogoUrl(content),
  ];
  for (const url of urls) {
    if (!url || requested.has(url)) continue;
    requested.add(url);
    const img = new Image();
    img.decoding = 'async';
    img.onload = img.onerror = () => {
      const i = inFlight.indexOf(img);
      if (i >= 0) inFlight.splice(i, 1);
    };
    inFlight.push(img);
    img.src = url;
  }
}
